import { makeStyles } from "@material-ui/core";
import { Autocomplete, TextField } from "@mui/material";
import { useEffect } from "react";
import classes from "../CustomInputs.module.css";

const useStyles = makeStyles({
  option: {
    background: "white !important",
    "&:hover": {
      background: "rgb(245,245,245) !important"
    }
  }
});

const AutocompleteInput = (props) => {
  const styles = useStyles();

  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
  }, [props.value]);

  return (
    <div className={classes.customTextField}>
      <Autocomplete
        disableClearable
        disablePortal
        defaultValue={props?.defaultValue ? props.defaultValue : null}
        value={props.value}
        isOptionEqualToValue={(option, value) => option.key === value.key}
        onChange={(event, newValue) => {
          props.onChange({ [props.id]: newValue?.label });
        }}
        id="autocompleteInput"
        options={props.list}
        className={classes.textField}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option?.id}>
              {option?.label}
            </li>
          );
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
              label={props.label}
            />
          );
        }}
        classes={{
          option: styles.option,
          inputRoot: classes.filed,
          paper: classes.menuPaper,
        }}
      />
    </div>
  );
};

export default AutocompleteInput;
